module.exports = __webpack_public_path__ + "img/manager2_red.fa7a5e27.jpg";